var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-mention",
      class: { edit: _vm.isSelected, hide: _vm.stickerInstance.data.isHide },
      on: { click: _vm.finish },
    },
    [
      _vm.isSelected
        ? [
            _vm.isHide
              ? _c("i", {
                  staticClass: "fa-solid fa-eye",
                  on: { click: _vm.toggleHide },
                })
              : _c("i", {
                  staticClass: "fa-solid fa-eye-slash",
                  on: { click: _vm.toggleHide },
                }),
          ]
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "sticker sticker-mention",
          class: {
            [`style${_vm.stickerInstance.data.styleVariant}`]: true,
          },
          on: { click: _vm.stickerInstance.nextStyleVariant },
        },
        [
          _c("div", { staticClass: "icon" }),
          _c("p", {
            ref: "mentionInput",
            staticClass: "textarea",
            attrs: { contenteditable: _vm.isSelected },
            domProps: { innerHTML: _vm._s(_vm.models.mention) },
            on: { input: _vm.handlerInput },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "mentions hide-scrollbar",
          on: { wheel: _vm.handleHorizontalScroll },
        },
        [
          _vm.stateLoader && _vm.models.mention.length
            ? _c("div", { staticClass: "mention-loader" }, [
                _c("span", { staticClass: "loader" }),
              ])
            : _vm._l(_vm.mentions, function (m) {
                return _c(
                  "div",
                  {
                    key: m.id,
                    staticClass: "mention",
                    class: {
                      selected:
                        _vm.stickerInstance.data.mention &&
                        _vm.stickerInstance.data.mention.id === m.id,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.selectMention(m)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: m.image ? m.image : "img/avatar.jpg",
                        alt: "",
                      },
                    }),
                    _c("p", [_vm._v(_vm._s(m.id))]),
                    _vm.stickerInstance.data.mention &&
                    _vm.stickerInstance.data.mention.id === m.id
                      ? _c("i", {
                          staticClass: "fa-solid fa-circle-check mention-check",
                        })
                      : _vm._e(),
                  ]
                )
              }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }